import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdDone } from "react-icons/md";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import { useResultContext } from "../../../src/app";

function Products({
  products,
  onAddToCart,

  ProductView,
}) {
  const [checkout, setcheckout] = useState(false);
  const { setactive } = useResultContext();

  return (
    <div className="mt-[100px] phone:mt-[74px]">
      <Link onClick={() => setactive(null)} to="/cart">
        <div
          className={`${
            checkout
              ? "h-14 translate-y-[0%] duration-700 cursor-pointer w-full bg-primary-100 fixed bottom-0  shadow-[0_35px_60px_15px_rgba(0,0,0,1.5)] right-0 z-50 transform -translate-x-[0]   "
              : "h-14 translate-y-[100%] cursor-pointer w-full bg-primary-100 fixed bottom-0  shadow-[0_35px_60px_15px_rgba(0,0,0,1.5)] right-0 z-50 transform duration-700 -translate-x-[0]   "
          }z-[100000000]`}
        >
          <div className="flex space-x-5 justify-center items-center my-[14px]  text-white">
            <MdDone className="bg-white rounded-full md:w-8 md:h-8 w-6 h-6 text-primary-100 p-[3px]" />
            <h1 className="uppercase leading-3 font-font text-[15px] md:text-xl">
              Check out
            </h1>
          </div>
        </div>
      </Link>
      <div className="slm">
        <div className="bg-primary-100 relative flex justify-center items-center font-font1 text-[50px] w-full h-[250px]">
          <img
            className="absolute object-cover w-full h-[250px]"
            src="https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
            alt="sky"
          />
          <h1 className="z-50 text-gray-900 main-titles text-center">
            Products
          </h1>
        </div>
      </div>
      <div>
        <div className="grid justify-center mt-[200px] phonex2:mt-[130px] ">
          <div className=" gap-y-40 phonex2:gap-y-32 grid grid-cols-3 phonex2:grid-cols-1 gap-12  phone:flex-wrap tablet:grid-cols-2 justify-center  text-center ">
            {products.map((product, index) => {
              return (
                <div
                  key={index}
                  className="group max-w-[300px] sm:max-w-[380px] ease-in-out duration-500  hover:scale-110  hover:bg-primary-100 hover:text-white font-font1 rounded-md  text-black h-[460px] sm:h-[550px] flex flex-col justify-end text-center"
                >
                  <Link to={`/product-page/${product.id}`}>
                    <img
                      onClick={() => {
                        ProductView(product.id, 1);
                      }}
                      className="flex aspect-square m-auto max-h-[250px] sm:max-h-[350px] cursor-pointer"
                      src={product.image.url}
                      alt={product.name}
                    />
                  </Link>{" "}
                  <div className="px-4 md:px-8 pb-8">
                    <h1 className="main-mini-titles py-2 font-font1 cursor-pointer">
                      {product.name}
                    </h1>

                    <HTMLEllipsis
                      className="text-center mb-4 demitablet:text-[14px]   group-hover:text-white text-gray-800 font-font"
                      unsafeHTML={product.description}
                      maxLine="3"
                      basedOn="letters"
                    />

                    <div className="py-2 space-x-10 phone:space-x-0 phone:flex phone:flex-col   phonex2:flex-wrap phonex2:flex phonex2:justify-center phonex2:text-center phonex2:items-center">
                      <span className="font-font2 phone:flex phone:justify-center ">
                        1 x 250ml
                      </span>
                      <span className="font-font1 text-2xl phone:m-0">
                        ${product.price.raw}
                      </span>
                    </div>
                    <div className="py-2 phone:flex-col  flex justify-around items-center ">
                      <button
                        onClick={() => {
                          onAddToCart(product.id, 1);
                          setcheckout(true);
                        }}
                        className="border-2 phone:w-full phonex2:w-full group-hover:bg-white hover:shadow-lg bg-primary-100 text-white group-hover:text-gray-900 py-4 px-6 md:px-10 rounded-md"
                      >
                        Add To Cart
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
